var ItemsCollection = (function (Collection, ItemModel) {
	return Collection.extend({
		model: ItemModel,
        parseAndUpdate: function (data) {
            this._display = !data.UseLocationDeliveryPriceSettings;
            this.update(data.Items);
        }
	});
})(CheckoutApiCollection, ItemModel);

var ShipmentItemsCollection = (function (Collection, ItemModel) {
    return Collection.extend({
        model: ItemModel,
        initialize: function () {
            this._display = true;
        }
    });
})(CheckoutApiCollection, ItemModel);

var ShipmentModel = (function (Model, ShipmentItemsCollection) {
    return Model.extend({
        initialize: function (data) {
            this.set('DeliveryPriceSrc', window.toMoney(data.DeliveryPrice, GlobalSettings.CurrencySign));
            this.set('Items', new ShipmentItemsCollection(data.Items));
            this.set('AmountToPromoPriceSrc', window.toMoney(data.AmountToPromoPrice, GlobalSettings.CurrencySign));
            
            if(data.Items && data.Items[0] && data.Items[0].BrandName) {
              this.set('LinkToProducts', '/shop/brand-products/' + data.Items[0].BrandName);
            }
        }
    });
})(CheckoutApiModel, ShipmentItemsCollection);

var ShipmentsCollection = (function (Collection, ShipmentModel) {
    return Collection.extend({
        model: ShipmentModel,
        initialize: function () {
            _.bindAll(this, 'parseAndUpdate');
        },
        parseAndUpdate: function (data) {
            var list = [];
            this._display = data.UseLocationDeliveryPriceSettings;
            if (data.UseLocationDeliveryPriceSettings) {
                _.each(data.Shipments, function(shipment) {
                    var items = [];
                    _.each(shipment.Items, function(ID) {
                        var item = _.findWhere(data.Items, {ID: ID});
                        item && items.push(item);
                    });
                    shipment.Items = items;
                    list.push(shipment);
                });
            }
            this.update(list);
        },
        shippingAvailability: function () {
            return !(this.where({ 'ShippingAvailability': false }).length > 0);
        }
    });
})(CheckoutApiCollection, ShipmentModel);